import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["text", "type"],
  _excluded2 = ["text"];
import "core-js/modules/es.string.trim.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import classnames from 'classnames';
import { BackgroundImage } from "../../Image/BackgroundImage/BackgroundImage";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Link } from "../../Button/Link/Link";
import { Button } from "../../Button/Button/Button";
import { SourceSet } from "../../Responsive/SourceSet/SourceSet";
import { Text } from "../../Text/Text/Text";
import { PricingForm } from "../../Price/PricingForm/PricingForm";
import { MatchHeightElement } from "../../Utility/MatchHeight/MatchHeightElement";
import { useShowHidePricingFormWithZip } from "../../Utility/Hooks";
import styles from "./LargeProductSquare.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LargeProductSquare = function LargeProductSquare(_ref) {
  var _background$mobile, _background$mobile$im, _background$desktop, _background$desktop$i, _background$desktop2, _background$desktop2$, _pricing$input, _pricing$input2;
  var _ref$background = _ref.background,
    background = _ref$background === void 0 ? {} : _ref$background,
    title = _ref.title,
    _ref$subhead = _ref.subhead,
    subhead = _ref$subhead === void 0 ? '' : _ref$subhead,
    errorMessage = _ref.errorMessage,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {} : _ref$cta,
    _ref$learn = _ref.learn,
    learn = _ref$learn === void 0 ? {} : _ref$learn,
    pricing = _ref.pricing,
    _ref$showPricingForm = _ref.showPricingForm,
    showPricingFormInit = _ref$showPricingForm === void 0 ? false : _ref$showPricingForm;
  var _useShowHidePricingFo = useShowHidePricingFormWithZip(showPricingFormInit),
    autoFocus = _useShowHidePricingFo.autoFocus,
    showPricingForm = _useShowHidePricingFo.showPricingForm,
    onZipClick = _useShowHidePricingFo.onZipClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var onHoverChange = function onHoverChange(isHoveredArg) {
    setIsHovered(isHoveredArg);
  };
  var renderButton = function renderButton(cta) {
    var text = cta.text,
      type = cta.type,
      otherProps = _objectWithoutProperties(cta, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      type: "link-quaternary",
      className: styles.linkButton
    }, otherProps), {}, {
      children: text
    }));
  };
  var renderLink = function renderLink(cta) {
    var text = cta.text,
      otherProps = _objectWithoutProperties(cta, _excluded2);
    var tabIndex = text ? -1 : 0;
    return /*#__PURE__*/_jsx(Link, _objectSpread({
      "aria-hidden": true,
      className: styles.backgroundLink,
      tabIndex: tabIndex
    }, otherProps));
  };
  var ariaLabel = background !== null && background !== void 0 && background.alt ? background.alt.trim() : undefined;
  var role = !!ariaLabel ? 'img' : undefined;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames({
      [className]: true,
      [styles.largeProductSquare]: true,
      [styles.hovered]: isHovered
    }),
    onMouseEnter: function onMouseEnter() {
      onHoverChange(true);
    },
    onMouseLeave: function onMouseLeave() {
      onHoverChange(false);
    },
    children: [/*#__PURE__*/_jsx(MatchHeightElement, {
      group: "large-product-square",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.imageWrapper,
        children: [(cta === null || cta === void 0 ? void 0 : cta.url) && renderLink(cta), /*#__PURE__*/_jsxs("div", {
          className: styles.imageWrapperZoom,
          children: [(background === null || background === void 0 ? void 0 : (_background$mobile = background.mobile) === null || _background$mobile === void 0 ? void 0 : (_background$mobile$im = _background$mobile.image) === null || _background$mobile$im === void 0 ? void 0 : _background$mobile$im.image1x) && /*#__PURE__*/_jsxs(SourceSet, {
            children: [/*#__PURE__*/_jsx(BackgroundImage, {
              className: classnames(styles.image, styles.mobileImage),
              uri: background.mobile.image.image1x,
              positionX: "left",
              positionY: "bottom",
              "aria-label": ariaLabel,
              role: role
            }), background.mobile.image.image2x && /*#__PURE__*/_jsx(BackgroundImage, {
              className: classnames(styles.image, styles.mobileImage),
              uri: background.mobile.image.image2x,
              positionX: "left",
              positionY: "bottom",
              "aria-label": ariaLabel,
              role: role
            })]
          }), (background === null || background === void 0 ? void 0 : (_background$desktop = background.desktop) === null || _background$desktop === void 0 ? void 0 : (_background$desktop$i = _background$desktop.image) === null || _background$desktop$i === void 0 ? void 0 : _background$desktop$i.image1x) && /*#__PURE__*/_jsxs(SourceSet, {
            children: [/*#__PURE__*/_jsx(BackgroundImage, {
              className: classnames(styles.image, styles.desktopImage),
              uri: background.desktop.image.image1x,
              positionX: "center",
              positionY: "bottom",
              "aria-label": ariaLabel,
              role: role
            }), background.desktop.image.image2x && /*#__PURE__*/_jsx(BackgroundImage, {
              className: classnames(styles.image, styles.desktopImage),
              uri: background.desktop.image.image2x,
              positionX: "center",
              positionY: "bottom",
              "aria-label": ariaLabel,
              role: role
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.textContainer, !(background !== null && background !== void 0 && (_background$desktop2 = background.desktop) !== null && _background$desktop2 !== void 0 && (_background$desktop2$ = _background$desktop2.image) !== null && _background$desktop2$ !== void 0 && _background$desktop2$.image1x) && styles.noDesktopImage),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.headingPriceContainer,
          children: /*#__PURE__*/_jsxs(MatchHeightElement, {
            group: "heading-text",
            children: [/*#__PURE__*/_jsx(HeadingText, {
              typog: "headline5",
              ariaLevel: 5,
              className: styles.heading,
              children: title
            }), subhead && /*#__PURE__*/_jsx(Text, {
              className: styles.pricing,
              typog: "bodycopy",
              children: subhead
            }), (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.text) && /*#__PURE__*/_jsx(Text, {
              typog: "bodycopy",
              className: classnames({
                [styles.error]: true,
                [styles.errorRed]: errorMessage.red
              }),
              children: errorMessage.text
            })]
          })
        }), ((learn === null || learn === void 0 ? void 0 : learn.text) && (learn === null || learn === void 0 ? void 0 : learn.url) || (cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url)) && /*#__PURE__*/_jsxs("div", {
          className: styles.linksContainer,
          children: [(learn === null || learn === void 0 ? void 0 : learn.text) && (learn === null || learn === void 0 ? void 0 : learn.url) && /*#__PURE__*/_jsx("div", {
            className: styles.learnContainer,
            children: renderButton(learn)
          }), (cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url) && /*#__PURE__*/_jsx("div", {
            className: styles.ctaContainer,
            children: renderButton(cta)
          })]
        }), (pricing === null || pricing === void 0 ? void 0 : (_pricing$input = pricing.input) === null || _pricing$input === void 0 ? void 0 : _pricing$input.regex) && /*#__PURE__*/_jsx(PricingForm, {
          pricing: _objectSpread(_objectSpread({}, pricing), {}, {
            input: _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, pricing.input), {}, {
              inputClassName: styles.pricingInput,
              buttonClassName: styles.pricingButton
            })), {}, {
              arrowButton: true,
              small: true,
              autoFocus: autoFocus,
              className: styles.pricingForm,
              onSubmit: pricing !== null && pricing !== void 0 && (_pricing$input2 = pricing.input) !== null && _pricing$input2 !== void 0 && _pricing$input2.onSubmit ? pricing.input.onSubmit : function () {}
            })
          }),
          isOpen: showPricingForm,
          onZipClick: onZipClick,
          zipTypog: "bodycopySmall",
          zipButtonClassName: styles.zip
        })]
      })
    })]
  });
};